<div class="ca-content">
  <div class="main">
    <img class="img-responsive ca-logo" src="/assets/images/logo@2x.png" />
    <ng-content></ng-content>
    <div class="ca-content-footer">
      <a href="https://careapp.com.au/privacy-policy">Privacy</a>
      &bull;
      <a href="https://careapp.com.au/privacy-policy">Terms</a> &bull;
      <a href="http://helpdesk.careapp.com.au">Help &amp; Support</a>
    </div>
  </div>
</div>
